import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Button, Flex, Image, Text } from '@chakra-ui/react';
import { formatAssetsUrl, renderSanitizedHtml } from '@whitbread-eos/utils';
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ConfirmationPromotion(_ref) {
  var data = _ref.data,
    routerPush = _ref.routerPush;
  if (!data.promotionPanel || data.promotionPanel.length === 0) {
    return null;
  }
  var _data$promotionPanel$ = data.promotionPanel[0],
    image = _data$promotionPanel$.image,
    name = _data$promotionPanel$.name,
    description = _data$promotionPanel$.description,
    linkLabel = _data$promotionPanel$.linkLabel,
    linkPath = _data$promotionPanel$.linkPath;
  return _jsxs(Flex, _objectSpread(_objectSpread({}, promoWrapperStyle), {}, {
    children: [image && _jsx(Box, _objectSpread(_objectSpread({}, imageWrapperStyle), {}, {
      "data-testid": 'promo-image',
      children: _jsx(Image, {
        src: formatAssetsUrl(image),
        alt: "Premier Inn Promo-Image",
        fit: "fill",
        objectFit: "cover"
      })
    })), _jsx(Box, {
      p: "lg",
      children: _jsxs(Flex, {
        direction: "column",
        children: [_jsx(Text, _objectSpread(_objectSpread({}, promoTitleStyle), {}, {
          "data-testid": 'promo-title',
          children: name
        })), _jsx(Box, _objectSpread(_objectSpread({}, promoDescriptionStyle), {}, {
          "data-testid": 'promo-description',
          children: renderSanitizedHtml(description)
        })), _jsx(Button, _objectSpread(_objectSpread({}, promoButtonStyle), {}, {
          "data-testid": 'promo-link',
          onClick: () => {
            routerPush(linkPath);
          },
          children: linkLabel
        }))]
      })
    })]
  }));
}
var promoWrapperStyle = {
  direction: 'column',
  w: 'full',
  bgColor: 'lightPurple'
};
var imageWrapperStyle = {
  pos: 'relative',
  w: '100%',
  h: '14.75rem'
};
var promoTitleStyle = {
  fontSize: 'md',
  color: 'baseWhite',
  fontWeight: 'medium'
};
var promoDescriptionStyle = {
  fontSize: 'sm',
  color: 'baseWhite',
  fontWeight: 'normal'
};
var promoButtonStyle = {
  size: 'full',
  variant: 'tertiary',
  mt: 'lg'
};